import { toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, Fragment as _Fragment, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "waybills-table-column-status" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_bs_status = _resolveComponent("bs-status")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (_ctx.status)
      ? (_openBlock(), _createBlock(_component_bs_status, {
          key: 0,
          color: _ctx.getColor()
        }, {
          default: _withCtx(() => [
            _createTextVNode(_toDisplayString(_ctx.status.title), 1)
          ]),
          _: 1
        }, 8, ["color"]))
      : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
          _createTextVNode(" — ")
        ], 64))
  ]))
}